export default "__VITE_ASSET__B9IBR6V9__"